import React from "react";
import PropTypes from "prop-types";
import { Button, Icons } from "@curves/ui-base";
import { useSkuAddToListContext } from "./SkuAddToListContext";

/**
 * ScanButton - 掃描按鈕子組件
 */
const ScanButton = ({ className = "", style = {}, ...otherProps }) => {
	const { handleOpenScanDialog } = useSkuAddToListContext();

	return (
		<Button
			className={className}
			style={{
				padding: '7px 12px',
				...style,
			}}
			onClick={handleOpenScanDialog}
			{...otherProps}
		>
			<Icons.CarrierCode />
		</Button>
	);
};

ScanButton.propTypes = {
	className: PropTypes.string,
};

ScanButton.displayName = "SkuAddToList.ScanButton";

export default ScanButton;
